import { guardNumber } from "../numbers";
import { guardString } from "../strings";
import type { Nullable } from "../types";
import { Constants } from "./constants";
import { getArticleProductTypeNumberString } from "./get-article-product-type-number-string";

// 1. Define an interface for the object approach
interface ArticleParams {
	articleGroupNumber: number;
	articleProductTypeNumber: number;
	number: number;
}

// 2. Overload Signatures
export function getArticleNumberString(params: Nullable<ArticleParams>): string;
export function getArticleNumberString(
	articleGroupNumber: number,
	articleProductTypeNumber: number,
	number: number,
): string;

// 3. Single Implementation
export function getArticleNumberString(
	arg1: number | Nullable<ArticleParams>,
	arg2?: number,
	arg3?: number,
) {
	let group: number;
	let type: number;
	let num: number;

	if (arg1 === null || arg1 === undefined) {
		return guardString(null);
	}

	// Logic to determine which overload was used
	if (typeof arg1 === "object") {
		group = arg1.articleGroupNumber;
		type = arg1.articleProductTypeNumber;
		num = arg1.number;
	} else {
		group = arg1;
		type = arg2!;
		num = arg3!;
	}

	const articleProductTypeNumberString = getArticleProductTypeNumberString(group, type);

	const articleNumberString = `${Constants.ARTICLE_NUMBER_PREFIX}${guardNumber(num)
		.toString()
		.padStart(Constants.ARTICLE_NUMBER_PADDING, "0")}`.trim();

	return [articleProductTypeNumberString, articleNumberString].join(Constants.NUMBER_JOINER);
}
